import { CircularProgress, Divider } from '@mui/material'
import CustomPaper from '../../containers/Paper'
import CustomInput from '../../components/TextInput'
import { useState } from 'react'
import CustomButton from '../../components/Button'
import { validateEmail } from '../../helpers/utils'
import RecoverPasswordService from '../../services/RecoverPasswordService'
import { useSnackbar } from 'notistack'
import useRecoverPassword from '../../hooks/useRecoverPassword'
import { RecoverAccountPage } from './RecoverPasswordPage'

interface Props {
    handleContinue: (page: RecoverAccountPage) => void
}

const ForgotPassword = ({ handleContinue }: Props) => {
    const [userEmail, setUserEmail] = useState<string>('')
    const [error, setError] = useState<string>('')
    const { enqueueSnackbar } = useSnackbar()
    const { setEmail } = useRecoverPassword()
    const [pending, setPending] = useState<boolean>(false)

    const validateInfo = () => {
        const newError =
            userEmail === ''
                ? 'Completá este campo.'
                : !validateEmail(userEmail)
                  ? 'El email ingresado no es válido.'
                  : ''

        setError(newError)

        return newError === ''
    }

    const handleRecoverPassword = async () => {
        if (!validateInfo()) return

        setPending(true)
        const response = await new RecoverPasswordService().forgotPassword(userEmail)
        if (response.status === 200) {
            setEmail(userEmail)
            handleContinue(RecoverAccountPage.RECOVERY_CODE)
        } else {
            enqueueSnackbar('Error inesperado', {
                variant: 'error',
                autoHideDuration: 6000,
            })
        }
        setPending(false)
    }

    return (
        <CustomPaper className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[350px] md:w-[450px] py-6">
            <div className="flex items-center justify-center gap-3 md:gap-6 px-2 mb-4 md:mb-8 w-[85%]">
                <img
                    src="/logo.png"
                    alt="logo"
                    className="h-[45px] md:h-[60px]"
                />
                <span className="text-primary font-semibold text-base md:text-xl">
                    Sistema de seguimiento de graduados
                </span>
            </div>
            <span className="text-secondary text-base md:text-xl">Recuperar Contraseña</span>
            <Divider />
            <div className="flex flex-col gap-3 md:gap-6 mt-4 md:mt-8">
                <span className="text-primary text-sm md:text-base">
                    Ingresá tu dirección de correo electrónico para que podamos enviarte un código
                </span>
                <CustomInput
                    type="text"
                    label="Email"
                    placeholder="Ingresá tu email"
                    name="email"
                    value={userEmail}
                    onChange={(e) => setUserEmail(e.target.value)}
                    errorText={error}
                />
            </div>
            <CustomButton
                className="w-full mt-3 md:mt-6"
                onClick={handleRecoverPassword}
                disabled={userEmail.length === 0 || pending}
            >
                {!pending ? (
                    'Enviar'
                ) : (
                    <CircularProgress
                        className="text-primary"
                        size={24}
                    />
                )}
            </CustomButton>
        </CustomPaper>
    )
}

export default ForgotPassword
